import { route, resolve } from './lib/router';
import { renderHome } from './pages/home';
import { renderCompound } from './pages/compound';
import { renderGoal } from './pages/goal';
import { maybeShowDisclaimer } from './lib/disclaimer';

const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());

route('/',         renderHome);
route('/compounds',renderHome);
route('/c/:id',    renderCompound);
route('/g/:id',    renderGoal);

maybeShowDisclaimer();
resolve();
